import React from 'react';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

const MarkdownParagraph = ({ markdownText }) => {
  const createMarkup = () => {
    const rawHtml = marked(markdownText);
    const sanitizedHtml = DOMPurify.sanitize(rawHtml);
    return { __html: sanitizedHtml };
  };

  return <p dangerouslySetInnerHTML={createMarkup()} />;
};

export default MarkdownParagraph;
